import React from "react";
import { Desktop } from "../containers/common";
import { Switch, Route, useRouteMatch } from "react-router-dom";

//screens
import {
  TriviaHome,
  Vendor,
  TriviaPlay,
  PickVoucher,
  ConfirmVoucher,
  TriviaCategorySelectPage,
  HistoryPage,
  RegionSelectionPage,
  LocationSelectionPage,
  TriviaPage,
  PickupLocationSelection,
  TriviaOrderDetails,
  RedemptionOnground,
  UserIdentification,
} from "../screens/subscriber/trivia";

const Loyalty = () => {
  const match = useRouteMatch();
  return (
    <Desktop phonebg={"white"}>
      <Switch>
        <Route path={`${match.path}/identification`} render={() => <UserIdentification />} />
        <Route path={`${match.path}/redeem-onground`} render={() => <RedemptionOnground />} />
        <Route path={`${match.path}/play`} render={() => <TriviaPlay />} />
        <Route path={`${match.path}/vendor`} render={() => <Vendor />} />
        <Route path={`${match.path}/pick`} render={() => <PickVoucher />} />
        <Route
          path={`${match.path}/select_pickup_location`}
          render={() => <PickupLocationSelection />}
        />
        <Route
          path={`${match.path}/order_details`}
          render={() => <TriviaOrderDetails />}
        />
        <Route
          path={`${match.path}/trivia-category`}
          render={() => <TriviaCategorySelectPage />}
        />
        <Route
          path={`${match.path}/region`}
          render={() => <RegionSelectionPage />}
        />
        <Route
          path={`${match.path}/location`}
          render={() => <LocationSelectionPage />}
        />
        <Route path={`${match.path}/trivia`} render={() => <TriviaPage />} />
        <Route path={`${match.path}/history`} render={() => <HistoryPage />} />
        <Route
          path={`${match.path}/confirm`}
          render={() => <ConfirmVoucher />}
        />
        <Route path={`${match.path}/`} render={() => <TriviaHome />} />
      </Switch>
    </Desktop>
  );
};

export default Loyalty;
